import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

export const FieldInfoMessage: React.FC<{ message: string }> = ({ message }) => (
  <div className="text-gray-400 mt-1 flex items-center space-x-2">
    <FontAwesomeIcon icon={faInfoCircle} className="text-blue-500" />
    <small className="italic">{message}</small>
  </div>
);